export default __webpack_public_path__ + "static/media/it-88.6da85a61.svg";